import { ICreateEntregaObraClienteTermoUseCase } from "../../../presentation/useCases/create/create_entrega_obra_cliente_termo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateEntregaObraClienteTermoUseCase
 */

export class CreateEntregaObraClienteTermoUseCase implements ICreateEntregaObraClienteTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraCliente: number,
    idTermo: number[]
  ): Promise<void> {
    await this.repository.createEntregaObrasClienteTermo(idEntregaObraCliente, idTermo);
  }
}
